import { ReactNode } from 'react';
import { formatDollars } from '~/utils';
import { UnitDecimals, RecProgramYear, RecProjectCategory } from '~/constants';
import { useProjectContext } from '~/hooks';
import { sizeKwac } from '~/utils/calculators';

interface ProjectRecsDataProps {
  recProjectCategory: string;
  recUtilityGroup: string;
  recProgramYear: string;
  recValue: number;
}

export const DisplayRECValue = (): ReactNode => {
  const { project } = useProjectContext();

  const projectKwac = sizeKwac(project) as number;
  const projectRecsData = project?.recsData ? project?.recsData[project?.addressState as string] : {};
  const { recProjectCategory, recUtilityGroup, recProgramYear, recValue } = projectRecsData as ProjectRecsDataProps; 

  const hasRecsData = Boolean(recProjectCategory && recUtilityGroup && recProgramYear);
  const hasRecsValue = Boolean(hasRecsData && projectKwac);
  const hasRoofTopArray = project?.projectArrays?.some((projectArray) => projectArray.type === 'ROOFTOP');
  const hasRooftopAdder = hasRecsValue &&
    hasRoofTopArray &&
    (recProgramYear === RecProgramYear.YEAR_2025_2026 || recProgramYear === RecProgramYear.YEAR_2026_2027) &&
    (recProjectCategory === RecProjectCategory.TRADITIONAL_COMMUNITY_SOLAR || recProjectCategory === RecProjectCategory.PUBLIC_SCHOOLS) &&
    project.deploymentType === 'COMMUNITY_SOLAR'
    ;
  
  //if size kwac has been entered, but not the recs data - TBD
  let recsValueInfo: string = 'TBD';
  if (hasRecsValue) {
    recsValueInfo = `${formatDollars(recValue, { dec: UnitDecimals.DOLLARS, default0: null })} / MWh`;
  } else if (!projectKwac) {
    recsValueInfo += ' - Please enter array size in kWac';
  }

  return (
    <>    
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--x-small)',  marginTop: 'var(--x-large)'}}>
        <h3 style={{ margin: '0'}}>{recProgramYear === RecProgramYear.FUTURE_PROGRAM_YEAR ? 'Estimated REC value -' :  'REC value — ' }</h3>
        <span style={{ color: 'var(--color-primary)', fontWeight: 'bold' }}>
          {recsValueInfo}
        </span>
      </div>
      {hasRooftopAdder && (
        <p style={{ marginTop: 'var(--x-small)' }}>Please note that your project qualifies for the <strong>new rooftop adder of $5/MWh</strong> which is factored in here.</p>
      )}
      {recProgramYear === RecProgramYear.FUTURE_PROGRAM_YEAR && (
        <p style={{ marginTop: 'var(--x-small)' }}>Please note that these numbers assume a <strong>5% decrease</strong> in REC value and are an estimation as future year REC value are not yet available.</p>
      )}
    </>
  );
};